// Stripe Configuration for Party Pass
// Replace the STRIPE_PAYMENT_LINK with your actual Stripe Payment Link URL
// You can create a Payment Link in your Stripe Dashboard:
// 1. Go to https://dashboard.stripe.com/payment-links
// 2. Click "Create payment link"
// 3. Set up your Party Pass product and pricing
// 4. Copy the payment link URL and paste it below

export const STRIPE_PAYMENT_LINK = process.env.REACT_APP_STRIPE_PAYMENT_LINK || "https://buy.stripe.com/6oU4gz4ug4TJ87zf9rgfu00";

// Success URL - where users are redirected after successful payment
// This should be set in your Stripe Payment Link settings to match this URL
export const STRIPE_SUCCESS_URL = `${window.location.origin}/party-pass/success?session_id={CHECKOUT_SESSION_ID}`;

// Cancel URL - where users are redirected if they cancel the payment
export const STRIPE_CANCEL_URL = `${window.location.origin}/`;
